/**
 * @file Accessibilite mouvement : "reduire les animations" = reglage du jeu OU preference systeme (prefers-reduced-motion).
 * L'UI pose la classe `reduce-motion` sur sa racine (CSS) et les composants animes en JS consultent `motionReduced()`.
 */
import type { UiContext } from '../UiContext';

const query = typeof matchMedia === 'function' ? matchMedia('(prefers-reduced-motion: reduce)') : null;

/** Preference systeme (Android "Supprimer les animations", iOS "Reduire les animations"...). */
export const systemReducedMotion = (): boolean => query?.matches ?? false;

/** Vrai si les animations amples (pop, rebond, rotation, confettis) doivent etre remplacees par de simples fondus. */
export const motionReduced = (ctx: UiContext): boolean => ctx.sim.data.settings.reduceMotion || systemReducedMotion();
